import { render } from "./Other.vue?vue&type=template&id=bf3fbc20&scoped=true&ts=true"
import script from "./Other.ts?vue&type=script&lang=ts"
export * from "./Other.ts?vue&type=script&lang=ts"

import "./Other.scss?vue&type=style&index=0&id=bf3fbc20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3fbc20"]])

export default __exports__